export const uniqueById = <T extends { id: number }>(
  items: T[],
  keySelector: (item: T) => string | number = item => item.id,
): T[] => {
  const seenKeys = new Set<string | number>();

  return items.filter((item) => {
    const key = keySelector(item);
    if (seenKeys.has(key)) return false;
    seenKeys.add(key);
    return true;
  });
};

export const shopItemSemanticKey = (item: { name: string; item_type: string }): string =>
  `${item.item_type.trim().toLocaleLowerCase()}:${item.name.trim().toLocaleLowerCase().replace(/\s+/g, ' ')}`;
